import FontAwesome from 'react-fontawesome'
import React from 'react'

class Burz extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-content">
          <div className="content is-medium">
            <div className="columns">
              <div className="column is-two-thirds">
                <center>
                  <img className="team-image" src="/images/burz.jpeg" role="presentation" />
                  <h3 className="title is-3">Anthony Burzillo</h3>
                  <h4 className="subtitle">Founder & CEO</h4>
                </center>
              </div>
              <div className="column team-column-links">
                <p>
                  <a href="mailto:burz@burnest.com">
                    <FontAwesome className="team-link-logo" name="envelope-open" /> burz@burznest.com
                  </a>
                </p>
                <p>
                  <a href="https://www.github.com/burz" target="_blank">
                    <FontAwesome className="team-link-logo" name="github" /> github.com/burz
                  </a>
                </p>
                <p>
                  <a href="https://www.linkedin.com/in/anthony-burzillo-66544a62" target="_blank">
                    <FontAwesome className="team-link-logo" name="linkedin" /> LinkedIn
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Burz



// WEBPACK FOOTER //
// ./src/Burz.js